export default "__VITE_ASSET__S_eIc97s__"